import React, { useContext } from 'react';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider';
import { useTranslation } from 'react-i18next';
import { PapiGallection } from '@wix/da-types-papi';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { MeasuredSlider as Slider } from '@wix/da-shared-react/pkg/Slider';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../../../UserWidgets/_partials/WidgetBox';
import PremiumFoldersEmptyState from '../../_partials/PremiumFoldersEmptyState';
import ShopThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Shop';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';
import PremiumFolderCreateButton from '../../_partials/PremiumFolderCreateButton/PremiumFolderCreateButton.connected';

import s from './PremiumFolderSlider.scss';

export interface Props {
  streamId: string;
  moduleId: number;
  folders: PapiGallection[];
  total: number;
  isOwner: boolean;
  username: string;
  isPremiumFoldersFeatureOn: boolean;
}

export const PremiumFolderSlider: React.FC<Props & WidgetBoxProps> = ({
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  moduleId,
  folders,
  total,
  username,
  section,
  zone,
  isOwner,
  isPremiumFoldersFeatureOn,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const isEmpty = !folders.length;

  if (!isPremiumFoldersFeatureOn) {
    return null;
  }

  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={t('common.premiumFolders')}
      headerExtras={
        isOwner &&
        !isMobile && <PremiumFolderCreateButton className={s['add-new']} />
      }
      count={total}
      moduleId={moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={isEmpty}
      hasMore={!isEmpty} // until we implement inner slider overflow recognition
      emptyView={<PremiumFoldersEmptyState view={'wide'} />}
      seeAllUrl={Url.userShopPath(
        username,
        USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_FOLDERS
      )}
    >
      {isMobile ? (
        <SwipeSlider>
          {folders.map(folder => (
            <ShopThumb key={folder.folderId} folder={folder} />
          ))}
        </SwipeSlider>
      ) : (
        <>
          <Slider
            renderSliderItems={elementSize =>
              folders.map(folder => (
                <ShopThumb
                  key={folder.folderId}
                  folder={folder}
                  width={elementSize.width}
                />
              ))
            }
          />
        </>
      )}
    </WidgetBox>
  );
};
PremiumFolderSlider.displayName = 'PremiumFolderSlider';

export default PremiumFolderSlider;
